<div class="container">
	<div class="row rightcomponent">
		<div class="" [dir]="currentDirection">
			<h2>Confiditial Policy</h2>
			<p>We care about your privacy and security. Our goal is to create
				a safe area for visitors to our website. We are not responsible for
				data that is created and sent by others.</p>
			<p>Here’s how we handle syour data:</p>
			<h4>What data we collect:</h4>
			<ul>
				<li><strong>Personal Information:</strong> Name, email address,
					phone number.</li>
				<li><strong>Content:</strong> your uploaed videos, photos,
					music, and other materials</li>
				<li><strong>Communication:</strong> Messages you send and
					receive on our site.</li>
				<li><strong>Geolocation:</strong> Information about your
					location based on network data or device location.</li>
				<li><strong>Technical Data:</strong> Information about your
					device and use of our site (e.g., IP address).</li>
			</ul>
			<h4>How we use your data:</h4>
			<ul>
				<li>To effectively operate our website.</li>
				<li>To protect your account and prevent fraud.</li>
			</ul>
			<h4>Data Sharing:</h4>
			<ul>
				<li>We do not sell your data.</li>
				<li>We may share your data only with our partners who help us
					maintain and develop the site (e.g., hosting and technical support,
					marketing department, or creators).</li>
				<li>We reserve the right to process data automatically and may
					share data for automated analysis with our partners who assist in
					maintaining and developing the site. We aim to enhance our service,
					your awareness, and your personal comfort. Some data may be
					collected for providing advertising offers.</li>
				<li>As required by applicable law, we may disclose data to
					competent government authorities.</li>
			</ul>
			<h4>Data Retention:</h4>
			<ul>
				<li>We retain your data only to many times as necessary to fulfill
					its purpose or as required by law.</li>
				<li>We do not store your data separately except in cases of
					automatic data processing by us and our partners. In automatic data
					processing, we do not guarantee that data will be attributed to
					you, except when maintaining attribution is the purpose of the
					collection. Often, data does not contain your personal information.</li>
			</ul>
		</div>
	</div>
</div>